import { jsx as _jsx } from "react/jsx-runtime";
export function RoundsEmptyState() {
  return /*#__PURE__*/_jsx("div", {
    className: "p-16 flex justify-center text-xl",
    children: "No rounds found"
  });
}